module.exports = __webpack_public_path__ + "img/Cutaways_house_2_low.04eb895d.jpg";